export function sanitizeInput(value) {
  if (typeof value === "string") {
    // Skip sanitizing if HTML tags are present
    if (/<[a-z][\s\S]*>/i.test(value)) {
      return value;
    }
    // Escape single quotes
    return value.replace(/'/g, "''");
  }

  if (Array.isArray(value)) {
    // Recursively sanitize array items
    return value.map(sanitizeInput);
  }

  if (value && typeof value === "object") {
    // Recursively sanitize object values
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [k, sanitizeInput(v)])
    );
  }

  // For numbers, booleans, null, undefined — return as-is
  return value;
}


export function isQuillEmpty(html) {
  if (!html) return true;
  // Remove all HTML tags
  const text = html.replace(/<[^>]+>/g, "").trim();
  // If no visible text remains → it's empty
  return text.length === 0;
}

export function setCookie({
  key = "responseToken",
  value,
  path = "/",
  duration = 12 * 60 * 60 * 1000, // 12 hours
} = {}) {
  const date = new Date();
  date.setTime(date.getTime() + duration);
  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${key}=${value}; ${expires}; path=${path};`;
}

export function getCookie({ key = "responseToken", browser = document  } = {}) {
  const cookies = browser?.cookie?.split("; ") || [];
  console.log("cookies", cookies);
  for (const cookie of cookies) {
    const [name, value] = cookie.split("=");
    if (name === key) return value;
  }
  return "";
}

export function deleteCookie({ key = "responseToken", path = "/" } = {}) {
  const pastDate = new Date(0);
  const expires = `expires=${pastDate.toUTCString()}`;
  document.cookie = `${key}=; ${expires}; path=${path};`;
}

/**
 * @param {Object} params
 * @param {string} [params.key] - localStorage key
 * @param {*} params.value - value to store
 * @param {number} [params.duration] - duration in ms
 */

export function setWithLocalExpiry({
  key = "responseToken",
  value,
  duration = 12 * 60 * 60 * 1000, // 12 hours
} = {}) {
  const now = Date.now(); // current timestamp in ms
  const item = {
    value,
    expiry: now + duration, // store the actual expiry timestamp
  };
  localStorage.setItem(key, JSON.stringify(item));
}

export function getWithLocalExpiry(key = "responseToken") {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return "";

  try {
    const item = JSON.parse(itemStr);
    if (!item.expiry || Date.now() > item.expiry) {
      localStorage.removeItem(key);
      return "";
    }
    return item.value;
  } catch {
    localStorage.removeItem(key);
    return "";
  }
}

export function deleteWithLocalExpiry(key = "responseToken") {
  localStorage.removeItem(key);
}


export function isValidBand(band){
return typeof band === 'number' ? isNaN(band) ? false : true : Boolean(band) 
}

export const AppConfig = {
  dollarRegex: /\$\d+(?:\+)?/,
  percentRegex: /\d\%+(?:\+)?/,
  removeStringSpace: /\s+/g,
  EM_NON_BILLABLE: "em-nonbillable",
  DL_NON_BILLABLE: "dl-nonbillable",
  STAFFING_SHEET_FORMULA: "Staffing Sheet",
  INAB_FORMULA: "INAB Formula",
  discountRegex: /[\d.]+/,
};

export function isHtml(text) {
  return /<\/?[a-z][\s\S]*>/i.test(text);
}

export const preserveSpaces = (html) =>
  html.replace(/ {2,}/g, (match) => "&nbsp;".repeat(match.length));

export const restoreSpaces = (html = "") =>
  html.replace(/&nbsp;/g, " ");


export const isSafeValue = (value) =>
  typeof value === 'number'
    ? !Number.isNaN(value)
    : typeof value === 'string'
    ? value.trim() !== ''
    : value !== null && value !== undefined;
